export default __webpack_public_path__ + "static/media/Upgrade.3db0e430.svg";